import IconButton from '@mui/material/IconButton';
import { ReactComponent as EyeIcon } from '../assets/icons/main/eye-icon.svg';
import { useTheme } from '@mui/material';

interface ViewButtonPropTypes {
  onClick: () => void;
  disabled?: boolean;
}

const Styles = {
  icon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
};

const ViewButton = ({ onClick, disabled }: ViewButtonPropTypes) => {
  const theme:any = useTheme();
  return (
    <IconButton onClick={onClick} disabled={disabled}>
      <EyeIcon style={{ ...Styles.icon, opacity: disabled ? 0.5 : 1, color: theme.palette.custom.light }} />
    </IconButton>
  );
};

export default ViewButton;
